export default {
  PUSH_TAG: 'PUSH_TAG',
  PUSH_TAGS: 'PUSH_TAGS',
  REPLACE_TAG: 'REPLACE_TAG',
  SET_IS_ADDING_TAG: 'SET_IS_ADDING_TAG',
  SET_IS_EDITING_TAG: 'SET_IS_EDITING_TAG',
  SET_SELECTED_TAG_GUID: 'SET_SELECTED_TAG_GUID',
  SET_TAGS_IS_LOADING: 'SET_TAGS_IS_LOADING',
};
